import { render, staticRenderFns } from "./plainLayout.vue?vue&type=template&id=88bb4f6a&scoped=true"
import script from "./plainLayout.vue?vue&type=script&lang=js"
export * from "./plainLayout.vue?vue&type=script&lang=js"
import style0 from "./plainLayout.vue?vue&type=style&index=0&id=88bb4f6a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88bb4f6a",
  null
  
)

export default component.exports